// WEAVE — alternating zigzag rows. Numbered rows where question and answer
// trade sides on every other row (flex row / row-reverse), separated by
// hairline top borders. Every answer visible — no accordion. All colors via
// ctx.v; the number badge sits on the accent-soft tint.
function itemHtml(ctx, it) {
    return `<div class="fq-row${it.idx % 2 === 1 ? ' fq-rev' : ''}"${ctx.reveal(it.idx)}>
  <div class="fq-qside">
    <span class="fq-num">${it.num}</span>
    <h3 class="fq-q">${it.q}</h3>
  </div>
  <div class="fq-a">${it.aHtml}</div>
</div>`;
}
const weave = {
    id: 'weave',
    name: 'Weave',
    tag: 'Alternating rows',
    styleTag: 'Rhythmic',
    description: 'Numbered rows that alternate direction, question and answer trading sides. A gentle zigzag rhythm that keeps long pages from feeling monotonous.',
    layout: 'list',
    defaultAccent: '#312d85',
    darkDefault: false,
    catSupport: 'none',
    features: ['reveal'],
    render(ctx) {
        const html = `<div class="fq-wrap">
  <h2 class="fq-title">${ctx.title}</h2>
  ${ctx.subtitle ? `<p class="fq-sub">${ctx.subtitle}</p>` : ''}
  <div class="fq-rows">
${ctx.items.map((it) => itemHtml(ctx, it)).join('\n')}
  </div>
</div>`;
        const css = `
.FQM .fq-wrap{max-width:800px;margin:0 auto}
.FQM .fq-title{margin:0 0 8px;font-family:${ctx.v.head};font-size:32px;font-weight:650;line-height:1.12;letter-spacing:-0.01em;color:${ctx.v.ink}}
.FQM .fq-sub{margin:0 0 24px;font-size:15.5px;line-height:1.6;color:${ctx.v.sub}}
.FQM .fq-row{display:flex;flex-wrap:wrap;gap:10px 36px;padding:26px 0;border-top:1px solid ${ctx.v.border}}
.FQM .fq-row.fq-rev{flex-direction:row-reverse}
.FQM .fq-qside{flex:1 1 240px;display:flex;align-items:flex-start;gap:12px}
.FQM .fq-num{flex:0 0 auto;display:grid;place-items:center;width:28px;height:28px;border-radius:8px;background:${ctx.v.soft};color:${ctx.v.accent};font-size:12px;font-weight:700}
.FQM .fq-q{margin:3px 0 0;font-size:17px;font-weight:600;line-height:1.4;color:${ctx.v.ink}}
.FQM .fq-a{flex:1.6 1 300px;min-width:0;font-size:15px;line-height:1.65;color:${ctx.v.sub}}
`;
        return { html, css };
    },
};
export default weave;
